import { UiListItem, UiListItemIcon } from "@smp/ui";
import { useMemo } from "react";

import { useStyles } from "./drawer_item_mock.css";
import { IProps } from "./drawer_item_mock.types";

export const DrawerItemMock = ({ Icon, ...props }: IProps) => {
  const classes = useStyles();

  return useMemo(
    () => (
      <UiListItem className={classes.list_item} button disabled {...props}>
        <UiListItemIcon className={classes.list_item__icon}>
          <Icon />
        </UiListItemIcon>
      </UiListItem>
    ),
    [classes, props, Icon],
  );
};
